import React, { useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  FormGroup,
  FormControl,
  FormLabel,
  Modal,
  FormCheck
} from "react-bootstrap";
import "./Login.scss";
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import opencardsIcon from "../../assets/opencards-icon.png";
import background from "../../assets/app/login/login-background-space.jpg";
import {
  languages,
  languageIcons,
  languageNames
} from "../../api/ReplayVariables";
import { APP_VERSION } from "../AppVariables";
import { sendCommand } from "../components/Bridge";

function Login({ history }) {
  const [show, setShow] = useState(false);
  const [logging, setLogging] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [time, setTime] = useState(new Date());
  const [lastShow, setLastShow] = useState(null);

  let _remember = localStorage.getItem("remember") === "true";

  const [remember, setRemember] = useState(_remember);

  const forgotClicked = () => {
    sendCommand("gui/login/forgotClicked");
  };

  const subscribeClicked = () => {
    sendCommand("gui/login/subscribeClicked");
  };

  function handleSubmit(event) {
    if (!logging) {
      setLogging(true);
      event.preventDefault();
      console.log("username", username);

      axios.post(
        "http://localhost:8099/api/gui/login/url"
      )
        .then(function (response) {
          //handle success
          console.log("response", response.data);
          let bodyFormData = response.data;
          bodyFormData["login"] = username;
          bodyFormData["password"] = password;
          bodyFormData["isLogin"] = true;
          bodyFormData["isLogout"] = false;
          axios.post(
            window.serverUrl+"/common-login-opencards.php",
              bodyFormData, {
              headers : {
                  'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
              }
          })
          .then((response) => {
            let auth= response.data;
              console.log("auth2", auth);
              //userLogged(_user);
              if (auth.state === 1 || auth.state === 2) {
                console.log("logged");
                setError(null);
                if (remember) {
                  localStorage.setItem("username", username);
                  localStorage.setItem("password", password);
                }
                //1 - setLogged(true)
                axios.get(
                  "http://localhost:8099/api/gui/login/login",
                    {
                    headers : {
                        'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
                    },params:{
                      login : username,
                      password : password,
                      licence : auth.license
                    }
                })
                .then((response) => {
                  history.push("/app/content/1/1/0/session/0/date/desc");
                }).catch((err) => {
                  console.error("fetch problem", err);
                  setError(-1);
                  setLogging(false);
                });
              } else {
                console.log("not logged");
                switch (auth.state) {
                  case 0: {
                    //bad credentials
                    setError(t("replayApp.user.error_code." + auth.state));
                    break;
                  }
                  case 8: {
                    //multi login
                    setError(t("replayApp.user.error_code." + auth.state));
                    break;
                  }
                  case 5: {
                    //another account
                    setError(
                      t("replayApp.user.error_code." + auth.state).replace(
                        "[OTHER]",
                        auth.other
                      )
                    );
                    break;
                  }
                  case 999: {
                    //connected somewhere else
                    setError(t("replayApp.user.error_code." + auth.state));
                    break;
                  }
                  default: {
                    setError(t("replayApp.user.error_code." + auth.state));
                    break;
                  }
                }
              }
              setLogging(false);
            })
            .catch((err) => {
              console.error("fetch problem", err);
              setError(-1);
              setLogging(false);
            });
          })
        .catch(function (response) {
          //handle error
          console.log(response);
          setError(-1);
          setLogging(false);
    });
    }
  }

  const { t } = useTranslation();
  const switchLanguage = (lang) => {
    sendCommand("gui/switchLanguage", {language:lang + "_" + lang.toUpperCase()})
    document.location.href = document.location.href.replace(
      "/opencards/" + i18n.language + "/",
      "/opencards/" + lang + "/"
    );
  };

  useEffect(() => {
    if (show && lastShow === null) {
      setLastShow(new Date());
    }
    let timer = setInterval(() => {
      setTime(new Date());
      if (show) {
        if (time.getTime() - lastShow.getTime() >= 2 * 60 * 1000) {
          setShow(false);
          setLastShow(null);
        }
      }
    }, 1000);
    return () => {
      clearInterval(timer);
      console.debug("login effect done !");
    };
  }, [remember, show, lastShow, time]);

  return (
    <>
      <div
        id="xeester-login"
        style={{ backgroundImage: `url(${background})` }}
        onClick={() => {
          setUsername((u) => localStorage.getItem("username"));
          setPassword((p) => localStorage.getItem("password"));
          setShow(true);
        }}
      ></div>
      <div id="clock" className={show ? "none" : ""}>
        <div className="time">
          {" "}
          {new Intl.DateTimeFormat(i18n.language, {
            hour: "2-digit",
            minute: "2-digit"
          }).format(time)}
        </div>
        <div className="date">
          {new Intl.DateTimeFormat(i18n.language, {
            year: "numeric",
            month: "short",
            day: "2-digit"
          }).format(time)}
        </div>
      </div>
      <div
        id="punch-line"
        className={show ? "none" : ""}
        onClick={() => {
          setUsername((u) => localStorage.getItem("username"));
          setPassword((p) => localStorage.getItem("password"));
          setShow(true);
        }}
      >
        Envie de découvrir l'horizon infini des statistiques ?
      </div>
      <Modal
        show={show}
        backdrop={true}
        keyboard={false}
        centered
        dialogClassName="app-login-dialog"
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Body className="login-panel d-flex flex-column align-items-center">
          <div
            className="error"
            style={{ display: error !== null ? "flex" : "none" }}
          >
            {error}
          </div>
          <form
            onSubmit={handleSubmit}
            onClick={() => {
              console.log("clicked");
              setLastShow(new Date());
            }}
          >
            <img
              id="logo-login"
              className="img-fluid"
              src={opencardsIcon}
              alt=""
            />
            <FormGroup controlId={"" + Math.random()}>
              <FormLabel>{t("replayApp.user.login_username")}</FormLabel>
              <FormControl
                autoFocus
                defaultValue={username}
                disabled={logging}
                autoComplete="off"
                onChange={(e) => {
                  setUsername(e.target.value);
                  setLastShow(new Date());
                }}
              />
            </FormGroup>
            <FormGroup controlId={"" + Math.random()}>
              <FormLabel>{t("replayApp.user.password")}</FormLabel>
              <FormControl
                defaultValue={password}
                autoComplete="new-password"
                disabled={logging}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setLastShow(new Date());
                }}
                type="password"
              />
            </FormGroup>
            <FormGroup controlId="remember">
              <FormCheck
                label={t("replayApp.user.remember")}
                checked={remember}
                disabled={logging}
                value=""
                onChange={(e) => {
                  localStorage.setItem("remember", e.target.checked);
                  setRemember(e.target.checked);
                  setLastShow(new Date());
                }}
              />
            </FormGroup>
            <Button id="login-button" block type="submit" disabled={logging}>
              {t("replayApp.user.login")}
            </Button>
            <div className="d-flex">
              <div id="forgot-button" onClick={forgotClicked}>
                {t("replayApp.user.forgot")}
              </div>
              <Dropdown className="language-switcher">
                <Dropdown.Toggle className="d-flex">
                  <img src={languageIcons[i18n.language]} alt={i18n.language} />
                  {languageNames[i18n.language]}&nbsp;
                </Dropdown.Toggle>
                <Dropdown.Menu className="language-selector-menu">
                  {languages.map((language) => (
                    <Dropdown.Item
                      key={language}
                      eventKey={language}
                      onClick={() => switchLanguage(language)}
                    >
                      <img src={languageIcons[language]} alt={language} />
                      {languageNames[language]}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="version">
              {t("version")} {APP_VERSION}
            </div>
          </form>
          <Button
            id="signin-button"
            block
            onClick={subscribeClicked}
            target="_blank"
          >
            {t("replayApp.user.signUp")}
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default Login;
